import { render, staticRenderFns } from "./ProductVariants.vue?vue&type=template&id=975b89b2&scoped=true&"
import script from "./ProductVariants.vue?vue&type=script&lang=js&"
export * from "./ProductVariants.vue?vue&type=script&lang=js&"
import style0 from "./ProductVariants.vue?vue&type=style&index=0&id=975b89b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975b89b2",
  null
  
)

export default component.exports